
import { Component, inject, Inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AiKnowledgeService } from '../services/ai-knowledge.service';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';
import { ApplicationListComponent } from '../app-list/application-list.component';
import { App } from '@vendasta/embeddings';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxySnackbarModule, SnackbarService } from '@vendasta/galaxy/snackbar-service';

export interface DeleteCustomKnowledgeData {
  knowledgeSourceId: string;
}

@Component({
  selector: 'ai-knowledge-delete-custom-knowledge-dialog',
  imports: [
    TranslateModule,
    AiKnowledgeI18nModule,
    MatButtonModule,
    MatDialogModule,
    ApplicationListComponent,
    GalaxyLoadingSpinnerModule,
    GalaxySnackbarModule
],
  providers: [AiKnowledgeService],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './delete-custom-knowledge.component.html',
})
export class DeleteCustomKnowledgeComponent implements OnInit {
  private readonly knowledgeService = inject(AiKnowledgeService);
  private readonly snackbarService = inject(SnackbarService);
  readonly isLoading = signal(true);
  associatedApps = signal<App[]>([]);

  constructor(
    public dialogRef: MatDialogRef<DeleteCustomKnowledgeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteCustomKnowledgeData,
  ) {}

  async ngOnInit(): Promise<void> {
    this.associatedApps.set(await this.knowledgeService.listAllAppsForKnowledgeSource(this.data.knowledgeSourceId));
    this.isLoading.set(false);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  async delete(): Promise<void> {
    await this.knowledgeService.deleteKnowledgeSource(this.data.knowledgeSourceId);
    this.snackbarService.openSuccessSnack('DELETE_KNOWLEDGE.SUCCESSFULLY_DELETED');
    this.dialogRef.close(true);
  }
}
